import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Users, User } from "lucide-react";

const items = [
  { to: "/today", label: "Today", icon: Home, testid: "nav-today" },
  { to: "/connections", label: "Kept", icon: Users, testid: "nav-connections" },
  { to: "/profile", label: "You", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/chat")) return null;
  return (
    <nav
      className="sticky bottom-0 left-0 right-0 glass border-t border-border/60 z-30"
      data-testid="bottom-nav"
    >
      <ul className="grid grid-cols-3">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <li key={to}>
            <NavLink
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-xs tracking-wide uppercase transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              <Icon strokeWidth={1.5} className="h-5 w-5" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
